import { Container } from "@material-ui/core";
import { memo, ReactElement } from "react";

import { Grid } from "../../components/Grid";
import { useScrollDocument } from "../../hooks";

import styles from "./GenericScreen.module.scss";

type GenericScreenProps = {
  children: ReactElement | Array<ReactElement>;
};

export const GenericScreen = memo<GenericScreenProps>(({ children }) => {
  useScrollDocument();

  return (
    <Container className={styles.container}>
      <Grid
        container
        alignItems="center"
        className={styles.page}
        direction="column"
        justify="center"
        spacingInnerTop={{ xs: 8, sm: 10 }}
        spacingInnerRight={{ xs: 5, sm: 10 }}
        spacingInnerBottom={{ xs: 8, sm: 10 }}
        spacingInnerLeft={{ xs: 5, sm: 10 }}
      >
        {children}
      </Grid>
    </Container>
  );
});
